import React from "react";

import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Alert from "@mui/material/Alert";

import BlacklistTable from "./BlacklistTable/BlacklistTable";
import {OAuthContext} from "../../context/OAuthContext";
import {UserContext} from "../../context/UserContext";
import PageLayout from "../../layout/PageLayout";
import RequestResultSnackbar from "./RequestResultSnackbar/RequestResultSnackbar";

const Blacklist = () => {
    const {errorOauth} = React.useContext(OAuthContext);
    const {errorUser, setErrorUser} = React.useContext(UserContext);

    const handleCloseError = () => {
        setErrorUser(prevState => ({...prevState, error: false}))
    }

    return <PageLayout>
        {!errorOauth.error ?
            <Grid container>
                <Grid item xs={12}>
                    <BlacklistTable/>
                </Grid>
            </Grid>
            : <Alert severity="error"><Typography>{errorOauth.message}</Typography></Alert>}

        {errorUser.error ?
            <RequestResultSnackbar anchorOrigin={{vertical: "top", horizontal: "right"}}
                                   open={errorUser.error} onClose={handleCloseError}
                                   autoHideDuration={3000} status="error"
                                   message={errorUser.message}/> : null}


    </PageLayout>
}

export default Blacklist;